<div class="w-full">
  <button
    (click)="openUrl()"
    title="{{ url() }}"
    [disabled]="!active()"
    class="block rounded-lg transition-colors bg-[#DFE6FF]"
    [class.w-full]=fullWidth()
    [class.w-auto]=!fullWidth()
    [class.p-1]=small()
    [class.p-4]=!small()
    [class.cursor-pointer]="active()"
    [class.hover:opacity-80]="active()"
    [class.cursor-not-allowed]="!active()"
    [class.bg-gray-200]="!active()"
  >
    <div class="flex items-center justify-center">
      @if (this.icon() && this.icon() !== 'none') {
        <lucide-angular [img]="getIcon()" size="20" class="mr-3"
                        [class.text-black]="active()"
                        [class.text-gray-400]="!active()"></lucide-angular>
      }
      <span class="font-medium"
            [class.text-black]="active()"
            [class.text-gray-400]="!active()">{{ title() }}</span>
    </div>
  </button>
</div>
